// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"313":"178f4243","5464":"8174d302"}[chunkId] + ".chunk.css";
};